function r(e) {
  return typeof e == "number" && Number.isFinite(e);
}
export {
  r as isNumber
};
